import {
  serviceBase,
  massOperation,
  createErrorMessage,
  clearance,
  createSuccessMessage
} from "../service";
import api from "../api";
import NewTabForm from "../NewTabForm";

const Document = {
  ...serviceBase,
  clearance,
  resource: "documents",
  resourceRole: "document",
  copy: massOperation("copy"),
  move: massOperation("move"),
  previewData(
    params = {},
    onSuccess = () => {},
    onError = () => {},
    errorHandler = () => {}
  ) {
    params = api.helpers.clearResource(params);
    let { id, ...paramsExcludingId } = params;
    return api
      .post(`/${this.resource}/${id}:preview`, paramsExcludingId)
      .then(res => {
        onSuccess(res.data);
        errorHandler({});
        return res;
      })
      .catch(res => {
        createErrorMessage(res);
        errorHandler(
          res.response && res.response.data && res.response.data.errors
        );
        onError(res);
      });
  },
  previewHTML(params = {}, onSuccess = () => {}) {
    let { id, ...parametersExcludingId } = params;
    return api
      .post(`/${this.resource}/${id}/html:preview`, parametersExcludingId)
      .then(res => {
        onSuccess(res.data);
        return res;
      })
      .catch(res => {
        createErrorMessage(res);
      });
  },
  async previewPDF(params = {}) {
    let { id, ...paramsExcludingId } = params;
    const url = `${this.api.apiUrl}/${this.resource}/${id}/pdf:preview`;
    const clearance = await this.clearance();
    new NewTabForm(url, "post", clearance)
      .setParams(paramsExcludingId)
      .submit();
  },
  async massExport(params = {}, onSuccess = () => {}) {
    const url = `${this.api.apiUrl}/${this.resource}:export`;
    const clearance = await this.clearance();
    new NewTabForm(url, "post", clearance).setParams(params).submit();
    onSuccess();
  },
  updateList(
    ids = [],
    values = {},
    onSuccess = () => {},
    onError = () => {},
    errorHandler = () => {}
  ) {
    return api
      .patch(`/${this.resource}/`, {
        ids,
        values
      })
      .then(res => {
        createSuccessMessage("update");
        onSuccess(res.data);
        errorHandler({});
        return res;
      })
      .catch(res => {
        createErrorMessage(res);
        errorHandler(
          res.response && res.response.data && res.response.data.errors
        );
        onError(res);
      });
  }
};

Document.getList = function(
  params = {},
  onSuccess = () => {},
  onError = () => {}
) {
  params["content-filters"] = api.helpers.formFilters(
    params["content-filters"]
  );
  return serviceBase.getList.apply(Document, [params, onSuccess, onError]);
};
export default Document;
